import { computed, inject, Injectable, Signal } from '@angular/core';
import { ReadonlyRepositoryCollectionService } from '@softline/core';
import { AbcAnalysisSegmentsRepository } from '../repositories/abc-analysis-segments.repository';
import {
  AbcAnalysisSegmentDefinition,
  AbcAnalysisSegmentDefinitionsResult,
} from '../types/abc-analysis-segment-definition';
import { AbcAnalysisFilterStateService } from './abc-analysis-filter-state.service';

@Injectable()
export class AbcAnalysisSegmentsService extends ReadonlyRepositoryCollectionService<
  AbcAnalysisSegmentDefinition,
  AbcAnalysisSegmentDefinitionsResult,
  { abcAnalysisId: number }
> {
  private readonly filterState = inject(AbcAnalysisFilterStateService);

  override readonly params: Signal<{ abcAnalysisId: number }> = computed(() => ({
    abcAnalysisId: this.filterState.abcAnalysisId(),
  }));

  constructor() {
    super(inject(AbcAnalysisSegmentsRepository));
  }

  protected override getAll(
    result: AbcAnalysisSegmentDefinitionsResult | null | undefined
  ): AbcAnalysisSegmentDefinition[] {
    return result?.data ?? [];
  }

  protected override getId = (item: AbcAnalysisSegmentDefinition): string => item.segment;

  readonly orderedSegments = computed(() =>
    [...this.all()].sort((a, b) => a.segment_sequence - b.segment_sequence)
  );
}
